import { render, staticRenderFns } from "./ServiceMedia.vue?vue&type=template&id=968fad00&"
import script from "./ServiceMedia.vue?vue&type=script&lang=js&"
export * from "./ServiceMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports